import dayjs from "dayjs";

import {
  BlogPostFooter,
  CaseStudyCaption,
  HeaderContainer,
  MainHeader,
  SecondaryHeader,
  SecondarySubheader,
  Subheader,
  SubheaderContainer,
} from "./styles.styled";

interface HeaderProps {
  header: string;
  subheader?: string;
  secondarySubheader?: string;
  withoutPadding?: boolean;
  variant?: "default" | "caseStudy" | "blogPost";
  blogPostProps?: {
    date: string;
    author: string;
  };
  className?: string;
  headerIsSecondary?: boolean;
}

export const Header = ({
  header,
  subheader,
  secondarySubheader,
  withoutPadding,
  variant,
  blogPostProps,
  className,
  headerIsSecondary,
}: HeaderProps) => {
  return (
    <HeaderContainer withoutPadding={!!withoutPadding} className={className}>
      {variant === "caseStudy" && (
        <CaseStudyCaption>{"< CASE STUDY >"}</CaseStudyCaption>
      )}

      {variant === "blogPost" && (
        <CaseStudyCaption>{"< BLOG >"}</CaseStudyCaption>
      )}

      {headerIsSecondary ? (
        <SecondaryHeader>{header}</SecondaryHeader>
      ) : (
        <MainHeader>{header}</MainHeader>
      )}

      {(!!subheader || !!secondarySubheader) && (
        <SubheaderContainer>
          {subheader && <Subheader>{subheader}</Subheader>}

          {secondarySubheader && (
            <SecondarySubheader>{secondarySubheader}</SecondarySubheader>
          )}
        </SubheaderContainer>
      )}

      {blogPostProps && (
        <BlogPostFooter>
          <span>{dayjs(blogPostProps.date).format("L")}</span>

          <span>&#10034;</span>

          <span>{blogPostProps.author}</span>
        </BlogPostFooter>
      )}
    </HeaderContainer>
  );
};
